export var CHANGE_LANG = '[TRANSLATION] CHANGE LANGUAGE';
export var changeLang = function (lang) { return ({
    type: CHANGE_LANG,
    payload: { lang: lang },
}); };



//////////////////
// WEBPACK FOOTER
// ./src/translation/store/actions/translation.actions.ts
// module id = 1478
// module chunks = 81